// Types
import { TTechnology } from "Types";
// Interfaces
import { 
    IUpdateTechnologyRateAction, 
    IUpdateTechnologyVoteAction,
    IUpdateTechSideNoteListAction 
} from "Interfaces";

export class CaseReducerLogic {
    public updateTechnologySideNotesInList(updateTechSideNoteListAction: IUpdateTechSideNoteListAction, technologies: TTechnology[],
    areAdditionalTechnologies: boolean): boolean {
        for (let technology of technologies) {
            if (!areAdditionalTechnologies && 
            technology.originalTechnologyId && 
            technology.originalTechnologyId === updateTechSideNoteListAction.technologyId) {
                technology.sideNotes = [...updateTechSideNoteListAction.newTechnologySideNoteList];
                return true;
            } else if (areAdditionalTechnologies &&
            technology.id === updateTechSideNoteListAction.technologyId) {
                technology.sideNotes = [...updateTechSideNoteListAction.newTechnologySideNoteList];
                return true;
            }
        }

        return false;
    }

    public updateTechnologyVotesInList(updateTechnologyVoteAction: IUpdateTechnologyVoteAction, technologies: TTechnology[]): boolean {
        for (let technology of technologies) {
            if (technology.id === updateTechnologyVoteAction.technologyId) {
                if (technology.votes) {
                    if (updateTechnologyVoteAction.isCurrentUserVote) {
                        technology.votes.currentUserVote = updateTechnologyVoteAction.vote;
                    } else {
                        if (!updateTechnologyVoteAction.vote) {
                            technology.votes.userVotes =  technology.votes.userVotes.filter(userVote =>
                                userVote.userName.trim().toLowerCase() === updateTechnologyVoteAction.userEmailWhoVoted.trim().toLowerCase())
                        } else {
                            let otherUserAlreadyVoted = false;
                        
                            for (const otherUserVote of technology.votes.userVotes) {
                                if (otherUserVote.userName.trim().toLowerCase() === updateTechnologyVoteAction.vote.userName.trim().toLowerCase()) {
                                    otherUserVote.vote = updateTechnologyVoteAction.vote.vote;
                                    otherUserAlreadyVoted = true;
                                    break;
                                }
                            }

                            if (!otherUserAlreadyVoted) technology.votes.userVotes.push(updateTechnologyVoteAction.vote);
                        }
                    }

                    let positiveVoteCount: number =  technology.votes.userVotes.filter(userVote => userVote.vote > 0).length;
                    if (technology.votes.currentUserVote && technology.votes.currentUserVote.vote > 0) positiveVoteCount++;
                    
                    let averageVote: number = (positiveVoteCount / (technology.votes.userVotes.length + 1));
                    
                    technology.votes.averageVote = averageVote;
                } else {
                    let positiveVoteCount: number = 0;
                    
                    if (updateTechnologyVoteAction.vote.vote > 0) positiveVoteCount = 1;
                    
                    technology.votes = {
                        currentUserVote: updateTechnologyVoteAction.isCurrentUserVote ? updateTechnologyVoteAction.vote : undefined,
                        userVotes: updateTechnologyVoteAction.isCurrentUserVote ? [] : [updateTechnologyVoteAction.vote],
                        averageVote: positiveVoteCount
                    };
                }

                return true;
            }
        }

        return false;
    }
    
    public updateTechnologyRatesInList(updateTechnologyRateAction: IUpdateTechnologyRateAction, technologies: TTechnology[]): boolean {
        for (let technology of technologies) {
            if (technology.id === updateTechnologyRateAction.technologyId) {
                if (technology.rates) {
                    if (updateTechnologyRateAction.isCurrentUserRate) {
                        technology.rates.currentUserRate = updateTechnologyRateAction.rate;
                    } else {
                        if (!updateTechnologyRateAction.rate) {
                            technology.rates.userRates =  technology.rates.userRates.filter(userRate =>
                                userRate.userName.trim().toLowerCase() === updateTechnologyRateAction.userEmailWhoVoted.trim().toLowerCase())
                        } else {
                            let otherUserAlreadyRated = false;

                            for (const otherUserRate of technology.rates.userRates) {
                                if (otherUserRate.userName.trim().toLowerCase() === updateTechnologyRateAction.rate.userName.trim().toLowerCase()) {
                                    otherUserRate.rate = updateTechnologyRateAction.rate.rate;
                                    otherUserAlreadyRated = true;
                                    break;
                                }
                            }

                            if (!otherUserAlreadyRated) technology.rates.userRates.push(updateTechnologyRateAction.rate);
                        }
                    }

                    let averageRate: number = 0;
                    let rateCount: number = 0;

                    if (technology.rates && technology.rates.currentUserRate) {
                        averageRate = technology.rates.currentUserRate.rate;
                        rateCount++;
                    }

                    if (technology.rates.userRates && technology.rates.userRates.length >= 1) {
                        averageRate += technology.rates.userRates.reduce((partial_sum, userRate) => partial_sum + userRate.rate, 0); 
                        rateCount += technology.rates.userRates.length;
                    }

                    averageRate = averageRate / rateCount;
                    technology.rates.averageRate = averageRate;
                } else {
                    technology.rates = {
                        currentUserRate: updateTechnologyRateAction.isCurrentUserRate ? updateTechnologyRateAction.rate : undefined,
                        userRates: updateTechnologyRateAction.isCurrentUserRate ? [] : [updateTechnologyRateAction.rate],
                        averageRate: updateTechnologyRateAction.rate.rate
                    };
                }
                
                return true;
            }
        }

        return false;
    }
}

export const CaseReducerLogicSingleton = new CaseReducerLogic();